export default __webpack_public_path__ + "static/media/search-black.75e88afb.svg";